<template>
  <div ref="messageModal" class="fixed z-40 hidden transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
    <div ref="messageBox"
      class="flex items-center px-5 py-5 transition-all duration-200 transform translate-y-10 bg-black rounded-md opacity-0 sm:px-10 bg-opacity-80">
      <svg class="w-4 h-4 mr-2 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
      <p class="text-sm font-bold text-white sm:text-lg">商品已加入購物車</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopCartDialog",
  data() {
    return {
      timer: null,
      close_timer: null,
      call_close_timer: null,
    };
  },
  methods: {
    Reset() {
      this.timer != null ? clearTimeout(this.timer) : "";
      this.close_timer != null ? clearTimeout(this.close_timer) : "";
      this.call_close_timer != null ? clearTimeout(this.call_close_timer) : "";

      this.$refs.messageBox.classList.remove("transition-all", "duration-200");
      this.$refs.messageBox.classList.remove("translate-y-0", "opacity-100");
      this.$refs.messageBox.classList.add("opacity-0", "translate-y-10");
      setTimeout(() => {
        this.$refs.messageBox.classList.add("transition-all", "duration-200");
      }, 0);
    },
    OpenModal() {
      this.Reset();
      // 顯示並執行動畫
      this.$refs.messageModal.classList.remove("hidden");
      // 小延遲讓瀏覽器抓到 display 變化，觸發 transition

      this.timer = setTimeout(() => {
        this.$refs.messageBox.classList.remove("opacity-0", "translate-y-10");
        this.$refs.messageBox.classList.add("translate-y-0", "opacity-100");
        this.call_close_timer != null
          ? clearTimeout(this.call_close_timer)
          : "";
        this.call_close_timer = setTimeout(() => {
          this.$store.commit("shopcart_module/SetAddCartMessage", -99999);
        }, 3000); // 自動關閉
      }, 10);
    },
    CloseModal() {
      this.$refs.messageBox.classList.remove("translate-y-0", "opacity-100");
      this.$refs.messageBox.classList.add("opacity-0", "translate-y-10");
      this.close_timer != null ? clearTimeout(this.close_timer) : "";
      this.close_timer = setTimeout(() => {
        this.$refs.messageModal.classList.add("hidden");
      }, 300); // 等待動畫結束
    },
  },
  computed: {
    add_cart_message() {
      return this.$store.state.shopcart_module.add_cart_message;
    },
  },
  watch: {
    add_cart_message() {
      if (this.add_cart_message != 0) {
        this.OpenModal();
      } else {
        this.CloseModal();
      }
    },
  },
};
</script>
